"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var flexContainerPropsToCss = function flexContainerPropsToCss(_ref) {
  var flexDirection = _ref.flexDirection,
    alignItems = _ref.alignItems,
    justifyContent = _ref.justifyContent,
    flexWrap = _ref.flexWrap;
  return "\n    display: flex;\n    ".concat(flexDirection ? "flex-direction: ".concat(flexDirection, ";") : '', "\n    ").concat(alignItems ? "align-items: ".concat(alignItems, ";") : '', "\n    ").concat(justifyContent ? "justify-content: ".concat(justifyContent, ";") : '', "\n    ").concat(flexWrap ? "flex-wrap: ".concat(flexWrap, ";") : '', "\n");
};
var _default = exports["default"] = flexContainerPropsToCss;